<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      <vs-button v-if="allowReopen" color="danger" type="filled" @click="reOpen">Re open</vs-button>
        <!-- RIGHT COLUMN -->
        <div class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0">
            <template>
                <VuePerfectScrollbar class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">
                  <div class="ticket-list" ref="chatLog">
                    <div class="ticket-item" v-for="(ticket, index) in chatData" :key="index">
                        <div class="ticket-header">
                            <span class="agent-name">Message ID: {{ ticket.message_id }}</span>
                            <span class="agent-name">Date: {{ ticket.created_at }}</span>
                            <span class="agent-name">Created By: {{ ticket.agent_name }}</span>
                            
                      
                       
                        </div>
                        <div class="ticket-content">
                         {{ ticket.message }}
                            <!-- Add other ticket details here as needed -->
                        </div>
                    </div>
                  </div>
                </VuePerfectScrollbar>
                <div v-if="isOpened" class="chat__input flex p-4 bg-white w-full" style="position: absolute; bottom: 0">
                    <vs-input class="flex-1" placeholder="Type Your Message" v-model="params.message" />
                    <vs-select
                    class="inputx ml-4"
                    placeholder="status"
                    v-model="ticketStatus"
                    autocompletender>
                    <vs-select-item :key="index" :value="item.status" :text="item.status" v-for="(item,index) in statuses"/>
                  </vs-select>
                  <div class="img-container ml-4">
                  <file-upload
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :multiple="false"
                    :size="1024 * 1024 * 10"
                    v-model="params.files"
                    ref="upload">
                    <p v-if="params.files.length>0 && params.files[0].name">{{params.files[0].name}}</p>
                    <vs-button v-else icon-pack="feather" icon="icon-file" type="border"></vs-button>
                  </file-upload>
                  </div>              
                  <vs-button class="bg-primary-gradient ml-4" type="filled" @click="saveData">Send</vs-button>
                </div>                
            </template>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FileUpload from 'vue-upload-component'
import chatLog from '../../components/forms/ChatLog'
import axios from "@/axios.js"
import Button from '../../components/vuesax/button/Button.vue'
export default {
  data() {
    return {
      params               : {files:[],message:''},
      ticketStatus         : this.$route.params.status,
      chatData             : [],
      statuses             : [],
      active               : true,
      isHidden             : false,
      searchContact        : "",
      activeProfileSidebar : false,
      activeChatUser       : null,
      userProfileId        : -1,
      typedMessage         : "",
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70,
      },
      clickNotClose        : true,
      isChatSidebarActive  : true,
      isLoggedInUserProfileView: false,
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    }
  },
  computed: {
    allowReopen: function(){
      return (this.$store.state.AppActiveUser.name==='admin' || this.$store.state.AppActiveUser.name==='tom') && this.$route.params.status==='closed';
    },
    activeUser() {
      return 'active'
    },
    chatContacts() {
      return []
    },
    contacts() {
      return []
    },
    isActiveChatUser() {
      return (userId) => userId == this.activeChatUser
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    isOpened: function(){
      if(this.$route.params.status==='closed')
        return false;
      return true;
    }
  },
  methods: {
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    reOpen:function(){
      const obj = {
        id: this.$route.params.userId
      }
      let that = this;
      axios.put("/api/tickets",obj).then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
              that.openAlert('success','Success');
              that.$router.push({ path: '/tickets'});

          } else{
            that.openAlert('danger','Failed',data.data.messsage);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })      
    },
    saveData() {
        const formData =new FormData();
        formData.append('ticket', this.$route.params.userId);
        formData.append('status', this.ticketStatus === 'status' ? '' : this.ticketStatus);
        formData.append('message', this.params.message);
        if(this.params.files.length>0)
          formData.append('document',this.params.files[0].file);
        this.$vs.loading();
        let that = this;
        axios.post("/api/tickets",formData)
        .then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
            if(this.params.files.length>0)
              that.openAlert('success','Files uploaded');
            else
              that.openAlert('success','Success');
            that.setData();
          } else{
            that.openAlert('danger','Failed',data.data.messsage);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    setData: function(){
      this.params={files:[],message:''};
      let that = this;
      axios.get('/api/tickets/'+this.$route.params.userId)
      .then((response) => {
          that.chatData.splice(0);
          for(let i in response.data){
            let obj = JSON.parse(response.data[i].object);            
            that.chatData.push(obj);
          }
          that.$forceUpdate();
          console.log(that.chatData)
      })
      .catch(() => {  })
    },
    getStatuses: function(){
      let that = this;
      axios.get('/api/tickets?list=statuses')
      .then((response) => {
          that.statuses.splice(0);
          for(let i in response.data){            
            const obj = JSON.parse(response.data[i].object);
            that.statuses.push(obj);
          }
          that.$forceUpdate();
      })
      .catch(() => {  })
    }
  },
  components: {
    VuePerfectScrollbar,
    FileUpload,
    chatLog,
    Button
  },
  created() {
    
  },
  mounted() {
    this.getStatuses();
    this.setData();
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
<style lang="css">
.upload-btn-wrapper {
    margin-left:15px;
    margin-right:15px;
    position: relative;
    overflow: hidden;
    display: inline-block;
}

.upload-btn {        
    cursor:pointer;
}

.upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}
.ticket-list {
    padding: 10px;
    background-color: #f9f9f9; /* Light background for the list */
    border-radius: 5px; /* Slight rounding of corners */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

.ticket-item {
    display: flex;
    
    border-bottom: 1px solid #ddd; /* Separation between items */
    padding: 15px;
    margin-bottom: 10px;
    background-color: #ffffff; /* White background for each item */
    border-radius: 4px; /* Rounded corners for each item */
    transition: background-color 0.3s; /* Smooth transition for hover effect */
}

.ticket-item:hover {
    background-color: #f3f3f3; /* Slight color change on hover */
}

.ticket-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Space out header content */
    align-items: start;
    margin-bottom: 10px;
    font-size: 0.9em; /* Adjust size as needed */
    border-right: 2px solid black;
    color: #444444;
}

.agent-name {
    color: #333333; /* Darker color for emphasis */
    font-weight: 600; /* Semi-bold for agent names */
    margin-right: 15px; /* Spacing between agent names */
    margin-bottom: 10px; /* Spacing between agent names */
}

.created-date {
    color: #666666; /* Lighter color for date */
    font-style: italic; /* Italicize the date */
}

.ticket-content {
    padding: 10px;
    margin-left: 70px;
    width: 80%;
    display: flex;
    justify-content: start;
    align-items: center;
    color: #121212;
    font-size: 1.5em; 
    /* Slightly dark color*/

}
</style>